import * as Sentry from '@sentry/react';
import { isDev } from 'utils';
import pkg from '../../package.json';

if (!isDev()) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENVIRONMENT,
    integrations: [
      Sentry.browserSessionIntegration(),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ blockAllMedia: true, maskAllText: false, maskAllInputs: false }),
    ],
    tracesSampleRate: 0.5,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    release: pkg.version,
    ignoreErrors: [
      'TypeError: Failed to fetch',
      'TypeError: Load failed',
      'TypeError: NetworkError when attempting to fetch resource.',
    ],
    beforeSend(event) {
      // fitler out ResizeObserver errors https://github.com/juggle/resize-observer/issues/103#issuecomment-612853704
      if (event.level === 'error' && event.exception?.values) {
        event.exception.values = event.exception?.values?.filter(
          (ex) => !ex.value?.includes('ResizeObserver'),
        );

        if (event.exception?.values.length === 0) {
          return null;
        }
      }

      return event;
    },
  });

  console.debug('Sentry initialized on', import.meta.env.VITE_ENVIRONMENT);
}
